module.exports = __webpack_public_path__ + "media/images/riders/small/LAURIE_GREENLAND-a053ba1ca28abb2baed3130e68c14d50.png";